import type { AgendaItem } from "@elation/api-client/src/stitch-web";

/**
 * Projects a server reorder response onto current cache membership and payloads.
 *
 * Keeps current object fields for IDs still present (so newer CRUD updates win),
 * applies server `sortOrder` and ordering, drops IDs deleted locally, and appends
 * IDs created after the reorder started.
 */
export function applyServerReorderToCurrentItems(
  current: readonly AgendaItem[],
  serverOrdered: readonly AgendaItem[],
): AgendaItem[] {
  const currentById = new Map(current.map((item) => [item.id, item]));
  const serverIds = new Set(serverOrdered.map((item) => item.id));

  const ordered = serverOrdered.flatMap((serverItem) => {
    const currentItem = currentById.get(serverItem.id);
    if (!currentItem) return [];
    return [{ ...currentItem, sortOrder: serverItem.sortOrder }];
  });

  const createdDuringFlight = current.filter((item) => !serverIds.has(item.id));
  return [...ordered, ...createdDuringFlight];
}
